var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-details-dialog" },
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            fullscreen: true,
            "close-on-press-escape": false,
            "show-close": false,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          !_vm.isEmbedded
            ? _c(
                "div",
                {
                  staticClass: "order-details-title-bar",
                  attrs: { id: "order-details-title" },
                },
                [
                  _c("div", { staticClass: "order-number" }, [
                    _vm._v(
                      "\n        Order #" +
                        _vm._s(
                          _vm.order.order.displayable_order_id ||
                            _vm.order.order.order_id
                        ) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "el-dialog__headerbtn",
                      attrs: { type: "button", "aria-label": "Close" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("update:visible", false)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "el-dialog__close el-icon el-icon-close",
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.loading && _vm.error
            ? _c("div", { staticClass: "order-details-error" }, [
                _c("div", { staticClass: "order-details-error-content" }, [
                  _c("i", {
                    staticClass: "el-icon-warning-outline",
                    staticStyle: {
                      "font-size": "48px",
                      color: "#F56C6C",
                      "margin-bottom": "16px",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "16px",
                        "font-weight": "500",
                        "margin-bottom": "8px",
                      },
                    },
                    [
                      _vm._v(
                        "\n          Unable to load order details\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { color: "#6e6e6e" } }, [
                    _vm._v(
                      "\n          The order may not exist or could not be retrieved. " +
                        _vm._s(_vm.error.message) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.error.status
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            color: "#909399",
                            "margin-top": "4px",
                            "font-size": "12px",
                          },
                        },
                        [
                          _vm._v(
                            "\n          Error code: " +
                              _vm._s(_vm.error.status) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.loading && !_vm.error
            ? _c(
                "div",
                {
                  class: ["order-details-body", { embedded: _vm.isEmbedded }],
                  attrs: { id: "order-details-body" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "order-details-timeline" },
                    [
                      _c("OrderTimeline", {
                        attrs: { order: _vm.order },
                        on: {
                          "return-id": _vm.getReturnID,
                          "return-created": _vm.getValue,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { border: "1px solid #DEE5EC" } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "order-details-data",
                      attrs: { id: "order-details-data" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex flex-row items-center" },
                        [
                          _c("div", { staticClass: "order-number" }, [
                            _vm._v(
                              "\n            Order #" +
                                _vm._s(
                                  _vm.order.order.displayable_order_id ||
                                    _vm.order.order.order_id
                                ) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("OrderStatus", {
                            attrs: {
                              "order-status": _vm.order.order.state_name,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "flex flex-row items-center",
                          staticStyle: { margin: "16px 0" },
                        },
                        [
                          _c("div", { staticStyle: { "font-weight": "500" } }, [
                            _vm._v("\n            Date Placed:\n          "),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { "margin-left": "4px" } },
                            [
                              _c("time-zone-formatter", {
                                attrs: {
                                  "output-format": "MMM DD, YYYY",
                                  "current-time": _vm.order.order.created_at,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-weight": "500",
                                "margin-left": "26px",
                              },
                            },
                            [_vm._v("\n            Email:\n          ")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticStyle: { "margin-left": "4px" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.order.customer.customer_email) +
                                "\n          "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { attrs: { id: "order-details-items" } },
                        [
                          _vm.containsInstallationAsin
                            ? _c(
                                "el-alert",
                                {
                                  staticStyle: { "margin-bottom": "16px" },
                                  attrs: {
                                    title:
                                      "Installation Service — Do Not Refund or Return",
                                    type: "warning",
                                    closable: false,
                                    "show-icon": "",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v("\n              The ASIN "),
                                    _c("strong", [_vm._v("IG-5X-601-PIN")]),
                                    _vm._v(" is an "),
                                    _c("strong", [_vm._v("Installation")]),
                                    _vm._v(
                                      " service provided by a third party.\n              Do not process refunds or returns on this item.\n              Please check your resources for guidance on supporting installations, or reach out to your leadership for assistance.\n            "
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.order.order_items, function (item, idx) {
                            return _c("order-details-item-view", {
                              key: idx,
                              staticStyle: { "margin-bottom": "8px" },
                              attrs: {
                                title: item.title,
                                "variant-title": item.variant_title,
                                sku: item.sku,
                                status: item.status,
                                "pre-tax-price": item.pre_tax_price,
                                images: item.images,
                                items: item.items,
                                "sub-item": item.sub_items,
                                quantity: item.quantity,
                              },
                            })
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "order-details-price-totals",
                          staticStyle: { "margin-right": "25px" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "order-details-price-item flex flex-row",
                            },
                            [
                              _c("div", { staticClass: "flex-1" }, [
                                _vm._v(
                                  "\n              Subtotal\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formattedAmount(
                                      _vm.order.order.total_line_items_price
                                        .amount,
                                      _vm.order.order.total_line_items_price
                                        .currency_code
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.order.order.total_discounts.amount
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "order-details-price-item flex flex-row",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex-1 flex" },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          "\n                Discount\n              "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.order.order.discount_codes,
                                        function (discount_code) {
                                          return _c(
                                            "div",
                                            {
                                              key: discount_code.code,
                                              staticClass: "discount-code",
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(discount_code.code) +
                                                  " – " +
                                                  _vm._s(
                                                    _vm.formattedDiscountCode(
                                                      discount_code.type,
                                                      discount_code.amount
                                                    )
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formattedAmount(
                                          -_vm.order.order.total_discounts
                                            .amount,
                                          _vm.order.order.total_discounts
                                            .currency_code
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "order-details-price-item flex flex-row",
                            },
                            [
                              _c("div", { staticClass: "flex-1 flex" }, [
                                _c("div", [
                                  _vm._v(
                                    "\n                Tax\n              "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formattedAmount(
                                      _vm.order.order.total_tax.amount,
                                      _vm.order.order.total_tax.currency_code
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticStyle: { border: "1px solid #DEE5EC" },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "order-details-price-item flex flex-row",
                              staticStyle: { "font-weight": "500" },
                            },
                            [
                              _c("div", { staticClass: "flex-1 flex" }, [
                                _c("div", [
                                  _vm._v(
                                    "\n                Total\n              "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formattedAmount(
                                      _vm.order.order.total_price.amount,
                                      _vm.order.order.total_price.currency_code
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "order-details-price-item flex flex-row",
                          staticStyle: {
                            "font-weight": "500",
                            "margin-top": "40px",
                          },
                        },
                        [
                          _c("div", { staticClass: "flex-1 flex" }, [
                            _c("div", [
                              _vm._v("\n              Shipment\n            "),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { attrs: { id: "order-details-items" } },
                        _vm._l(_vm.shipmentsToShow, function (item, idx) {
                          return _c(
                            "shipping-details-item-view",
                            _vm._b(
                              {
                                key: idx,
                                staticStyle: { "margin-bottom": "8px" },
                                attrs: { "shipping-data": [item] },
                              },
                              "shipping-details-item-view",
                              item,
                              false
                            )
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _vm.shipmentsToShow.length === 0
                        ? _c(
                            "div",
                            { staticClass: "item-details" },
                            [_c("shipment-details-available-soon")],
                            1
                          )
                        : _vm.order.order_items.length > _vm.totalItemsShipped
                        ? _c(
                            "div",
                            { staticClass: "item-details" },
                            [
                              _c("shipment-details-not-available", {
                                attrs: {
                                  "total-shipments": _vm.shipmentsToShow.length,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "order-details-price-item flex flex-row",
                          staticStyle: { "font-weight": "500" },
                        },
                        [
                          _c("div", { staticClass: "flex-1 flex" }, [
                            _c("div", [
                              _vm._v(
                                "\n              Customer Info\n            "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { attrs: { id: "order-details-items" } },
                        [
                          _c("customer-details-item-view", {
                            staticStyle: { "margin-bottom": "8px" },
                            attrs: {
                              "billing-address":
                                _vm.order.order.billing_address,
                              "customer-data": _vm.order.customer,
                              "shipping-address":
                                _vm.order.order.shipping_address,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.error
            ? _c(
                "div",
                {
                  staticClass: "order-details-footer",
                  attrs: { id: "order-details-footer" },
                },
                [
                  _c(
                    "el-dropdown",
                    {
                      attrs: { trigger: "click" },
                      on: { command: _vm.handleAction },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "choose_action_button",
                          attrs: { plain: "" },
                        },
                        [
                          _vm._v("\n          Choose Action "),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-menu",
                        {
                          staticStyle: {
                            "max-height": "unset !important",
                            overflow: "unset !important",
                          },
                          attrs: { slot: "dropdown" },
                          slot: "dropdown",
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "box-item",
                              attrs: {
                                disabled:
                                  !_vm.checkRefundable &&
                                  !_vm.installationRefundBlocked,
                                content: _vm.installationRefundBlocked
                                  ? "Refunds and returns for installation services require leadership approval"
                                  : "No items in this order are currently eligible for return",
                                placement: "left",
                              },
                            },
                            [
                              _c(
                                "span",
                                [
                                  !_vm.showReturnRequest
                                    ? _c(
                                        "el-dropdown-item",
                                        {
                                          staticClass: "choose_action_item",
                                          attrs: {
                                            disabled:
                                              _vm.checkRefundable ||
                                              _vm.installationRefundBlocked,
                                            command: "return",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                Return Item(s)\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "box-item",
                              attrs: {
                                disabled:
                                  _vm.hasLisbonRefundPermission &&
                                  _vm.isLisbonOrder &&
                                  !_vm.checkRefundable &&
                                  !_vm.installationRefundBlocked,
                                content: _vm.installationRefundBlocked
                                  ? "Refunds and returns for installation services require leadership approval"
                                  : _vm.lisbonRefundDisabledTooltip,
                                placement: "left",
                              },
                            },
                            [
                              _c(
                                "span",
                                [
                                  !_vm.showRefundRequest
                                    ? _c(
                                        "el-dropdown-item",
                                        {
                                          staticClass: "choose_action_item",
                                          attrs: {
                                            disabled:
                                              !_vm.hasLisbonRefundPermission ||
                                              !_vm.isLisbonOrder ||
                                              _vm.checkRefundable ||
                                              _vm.installationRefundBlocked,
                                            command: "refund",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                Refund Item(s)\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "box-item",
                              attrs: {
                                disabled: _vm.order.order.cancellable,
                                content: _vm.order.order.cancellable_reason,
                                placement: "left",
                              },
                            },
                            [
                              _c(
                                "span",
                                [
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      staticClass:
                                        "choose_action_item action_cancel",
                                      attrs: {
                                        disabled: !_vm.order.order.cancellable,
                                        command: "cancel",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Cancel Order\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.showReturnRequest
        ? _c("ReturnDialog", {
            attrs: {
              visible: _vm.showReturnRequest,
              order: _vm.order,
              "total-tax": _vm.totalTax,
              "show-installation-warning": _vm.containsInstallationAsin,
            },
            on: {
              "update:visible": function ($event) {
                _vm.showReturnRequest = $event
              },
              "exit-order-details": _vm.exitOrderDetails,
              close: function ($event) {
                _vm.visible = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showReturnDetails
        ? _c("ReturnOrderDetails", {
            attrs: {
              visible: _vm.showReturnDetails,
              order: _vm.order,
              "return-id": _vm.returnId,
            },
            on: {
              "update:visible": function ($event) {
                _vm.showReturnDetails = $event
              },
              "exit-order-details": _vm.exitOrderDetails,
              close: function ($event) {
                _vm.visible = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showCancelRequest & _vm.order.order.cancellable
        ? _c("FullOrderCancelDialog", {
            attrs: { visible: _vm.showCancelRequest, order: _vm.order },
            on: {
              "update:visible": function ($event) {
                _vm.showCancelRequest = $event
              },
              "exit-cancel-order": _vm.exitCancelOrder,
              close: function ($event) {
                _vm.visible - false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showRefundRequest
        ? _c("RefundDialog", {
            attrs: {
              visible: _vm.showRefundRequest,
              order: _vm.order,
              "total-tax": _vm.totalTax,
              "is-lisbon-order": _vm.isLisbonOrder,
              "show-installation-warning": _vm.containsInstallationAsin,
            },
            on: {
              "update:visible": function ($event) {
                _vm.showRefundRequest = $event
              },
              "exit-order-details": _vm.exitOrderDetails,
              close: function ($event) {
                _vm.visible = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }